
const $6b17f08f738443dc$var$scrollers = document.querySelectorAll(".skills-section");
function $6b17f08f738443dc$var$addAnimation() {
    $6b17f08f738443dc$var$scrollers.forEach((scroller)=>{
        scroller.setAttribute("data-animated", true);
        const scrollerInner = scroller.querySelector(".skills-section-inner");
        const scrollerInnerContent = Array.from(scrollerInner.children);
        scrollerInnerContent.forEach((item)=>{
            const duplicatedItem = item.cloneNode(true);
            duplicatedItem.setAttribute("aria-hidden", true);
            scrollerInner.appendChild(duplicatedItem);
        });
    });
}
$6b17f08f738443dc$var$addAnimation();


//# sourceMappingURL=index.f30c5e9c.js.map
